/**
 * Mirrors the backend Kling 4.0 video-to-video pricing: output seconds plus
 * the longer of source and output seconds, at the input-video rate. An edit
 * output matches the source, so this is roughly 2x the source length.
 * Pixels track Runway credits 1:1.
 */
export const LIVE_ACTION_RATES: Record<string, number> = {
  '720p': 9.4,
  '1080p': 14.1,
};

export function estimateLiveActionPixels(input: {
  outputSeconds?: number;
  inputSeconds?: number;
  outputPixelsPerSecond: number;
}): number {
  const { outputSeconds, inputSeconds, outputPixelsPerSecond } = input;
  if (
    outputSeconds === undefined ||
    outputSeconds <= 0 ||
    !Number.isFinite(outputPixelsPerSecond) ||
    outputPixelsPerSecond <= 0
  ) {
    return 0;
  }
  const output = Math.max(0, Number(outputSeconds) || 0);
  const source = Math.max(0, Number(inputSeconds) || 0);
  return Math.ceil((output + Math.max(source, output)) * outputPixelsPerSecond);
}
